import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventCategory,
  GaTrackingEventName,
  GATrackingEventType,
  GaTrackingStringConstantEnum,
} from '../../constants';

export class GaTrackingInstallationServicesEvent implements GATrackingEvent {
  constructor(private servicesSelected: boolean) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.InstallationServices;
  }

  getPayload(): GATrackingEventPayload {
    const productPromoViewTracking = {
      category: GaTrackingEventCategory.Interaction,
      label: this.servicesSelected ? GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No,
    };

    return {
      event: GaTrackingEventName.InstallationServices,
      gtmCustom: productPromoViewTracking,
    };
  }
}
